export default __webpack_public_path__ + "static/media/jw-ILLUS.4835cb08.png";